import enLocale from 'element-ui/lib/locale/lang/en'

export default {
  ...enLocale,
  common: {
    confirm: 'Confirm',
    cancel: 'Cancel',
    save: 'Save',
    delete: 'Delete',
    edit: 'Edit',
    add: 'Add',
    search: 'Search',
    reset: 'Reset',
    submit: 'Submit',
    upload: 'Upload',
    download: 'Download',
    export: 'Export',
    import: 'Import',
    operation: 'Operation',
    status: 'Status',
    createTime: 'Create Time',
    updateTime: 'Update Time',
    name: 'Name',
    description: 'Description',
    id: 'ID',
    default: 'Default',
    yes: 'Yes',
    no: 'No',
    loading: 'Loading...',
    noData: 'No Data',
    success: 'Success',
    error: 'Error',
    warning: 'Warning',
    info: 'Info'
  },
  systemRole: {
    title: 'System Role Settings',
    selectGroup: 'Please select a group',
    addRole: 'Add Role',
    editRole: 'Edit Role',
    unnamedRole: 'Unnamed Role',
    modelPreviewNotSupported: 'Model preview not supported',
    noModelUploaded: 'No model uploaded',
    uploadModel: 'Upload Model',
    deleteRole: 'Delete Role',
    confirmDelete: 'Are you sure to delete this role?',
    confirmDeleteTitle: 'Tip',
    roleName: 'Role Name',
    roleDescription: 'Role Description',
    selectModel: 'Select Model',
    modelFormat: 'Model Format',
    avatar: 'Avatar',
    uploadAvatar: 'Upload Avatar',
    isDefault: 'Set as Default',
    save: 'Save',
    cancel: 'Cancel',
    edit: 'Edit',
    language: 'Language',
    speechRate: 'Speech Rate',
    pitchRate: 'Pitch Rate',
    volume: 'Volume',
    voice: 'Voice',
    defaultVoice: 'Default Voice',
    characterBackground: 'Character Background (Prompt)',
    noPrompt: 'No prompt',
    noSystemRoles: 'No system roles',
    clickToUpload: 'Click to Upload',
    clickToUploadAvatar: 'Click to Upload Avatar',
    avatarUploadTip: 'Supports JPG, PNG format, file size not exceeding 2MB',
    name: 'Name',
    namePlaceholder: 'Optional',
    prompt: 'Prompt',
    promptPlaceholder: 'System prompt',
    voicePlaceholder: 'e.g. female_1',
    languagePlaceholder: 'e.g. zh-CN',
    inputNumberError: 'Please enter a number',
    getGroupListFailed: 'Failed to get group list',
    saveSuccess: 'Save successful',
    saveFailed: 'Save failed',
    unknownError: 'Unknown error',
    deleteSuccess: 'Delete successful',
    setDefaultSuccess: 'Set as default',
    selectModelFile: 'Please select a model file to upload',
    modelUploadSuccess: 'Model upload successful',
    modelUploadFailed: 'Model upload failed',
    avatarFormatError: 'Avatar image must be JPG/PNG format!',
    avatarSizeError: 'Avatar image size cannot exceed 2MB!',
    avatarUploadSuccess: 'Avatar upload successful',
    avatarUploadFailed: 'Avatar upload failed',
    avatarLoadFailed: 'Avatar image load failed, please upload again',
    modelLoadFailed: 'Model load failed, please try again',
    reuploadModel: 'Re-upload',
    enableModelPreview: 'Enable Model Preview',
    domestic: 'Domestic',
    international: 'Overseas'
  },
  system: {
    paramManagement: 'System Parameter Management',
    limitConfig: 'Limit Configuration',
    asrDurationLimit: 'ASR Duration Limit',
    asrDurationLimitDesc: 'Maximum duration limit for single ASR (speech recognition) usage',
    milliseconds: 'milliseconds',
    appDownloadUrl: 'Client APP Download URL',
    uploadApp: 'Upload APP',
    llmTokenLimit: 'LLM Token Limit',
    ttsTokenLimit: 'TTS Token Limit',
    ttsTokenLimitDesc: 'Maximum token limit for single TTS (text-to-speech) usage',
    llmTokenLimitDesc: 'Maximum token limit for single LLM (large language model) usage',
    limitValidPeriodHours: 'Limit Validity Period',
    limitValidPeriodHoursDesc: 'Usage records within this time period are counted towards the limit',
    tokenCount: 'Token Count',
    hours: 'hours',
    saveSettings: 'Save Settings',
    uploadAfterAutoGenerate: 'Download URL will be generated automatically after upload',
    systemPrompt: 'systemPrompt',
    addLanguageFormat: 'Add',
    editLanguageFormat: 'Edit',
    languageCode: 'Code',
    languageName: 'Name',
    prompt: 'prompt',
    systemPromptTemplate: 'System Prompt Template',
    languageCodePlaceholder: 'Please enter language code (e.g., en, zh, yue, ja)',
    languageCodeDesc: 'Usually ISO 639-1 two-letter lowercase (e.g. en, zh, ja). Cantonese matches character/TTS: use yue.',
    languageNamePlaceholder: 'Please enter language name (e.g., English, Chinese, Japanese)',
    promptPlaceholder: 'Please enter prompt content, supports multi-line text, use \\n for line breaks',
    promptDesc: 'Prompt content, used to guide AI character behavior norms',
    systemPromptTemplatePlaceholder: 'Please enter system prompt template, must include %s placeholder (for replacing location information)',
    systemPromptTemplateDesc: 'System prompt template format suggestion: LANGUAGE: {language code}\\nLOCATION: %s\\nMAX_TOKENS: 2000',
    // 验证错误提示
    validationLanguageCodeRequired: 'Please enter language code',
    validationLanguageCodeFormat: 'Must be two lowercase letters or yue (e.g., en, zh, yue, ja)',
    validationLanguageNameRequired: 'Please enter language name',
    validationPromptRequired: 'Please enter prompt',
    validationSystemPromptTemplateRequired: 'Please enter system prompt template',
    validationSystemPromptTemplatePlaceholder: 'System prompt template must include %s placeholder (for replacing location information)',
    imageAgentApiKey: 'Image Agent API Key',
    imageAgentModel: 'Image Agent Model',
    version: 'Version',
    versionPlaceholder: 'Please enter version',
    catalogSize: 'Catalog Size',
    catalogHash: 'Catalog Hash',
    catalogHashPlaceholder: 'Please enter catalog hash',
    catalogUrl: 'Catalog URL',
    catalogUrlPlaceholder: 'Please enter catalog URL',
    bytes: 'Bytes',
    toolAgentApiKey: 'Tool Agent API Key',
    toolAgentApiKeyPlaceholder: 'Please enter tool agent API key',
    toolAgentModel: 'Tool Agent Model',
    toolAgentModelPlaceholder: 'Please enter tool agent model',
    actionAgentApiKey: 'Action Agent API Key',
    actionAgentApiKeyPlaceholder: 'Please enter action agent API key',
    actionAgentModel: 'Action Agent Model',
    actionAgentModelPlaceholder: 'Please enter action agent model',
    qwenConfig: 'Qwen Configuration',
    qwenApiKey: 'Qwen API Key',
    qwenApiKeyPlaceholder: 'Please enter Qwen API key',
    qwenApiUrl: 'Qwen API URL',
    qwenApiUrlPlaceholder: 'Please enter Qwen API URL',
    qwenModel: 'Qwen Model',
    qwenModelPlaceholder: 'Please enter Qwen model',
    qwenTtsApiKey: 'Qwen TTS API Key',
    qwenTtsApiKeyPlaceholder: 'Please enter Qwen TTS API key',
    qwenTtsModel: 'Qwen TTS Model',
    qwenTtsModelPlaceholder: 'Please enter Qwen TTS model',
    qwenAsrApiKey: 'Qwen ASR API Key',
    qwenAsrApiKeyPlaceholder: 'Please enter Qwen ASR API key',
    qwenAsrModel: 'Qwen ASR Model',
    qwenAsrModelPlaceholder: 'Please enter Qwen ASR model',
    ttskey: 'Clone Voice TTS API Key',
    ttskeyPlaceholder: 'Please enter Clone Voice TTS API Key',
    ttsmodel: 'Clone Voice TTS Model',
    ttsmodelPlaceholder: 'Please enter Clone Voice TTS Model',
    environment: 'Environment',
    environmentDomestic: 'Domestic',
    environmentOverseas: 'Overseas',
    environmentUnknown: 'Unknown'
  },
  home: {
    home: 'Home',
    modelCommunity: 'Model Community',
    creationCenter: 'Creation Center',
    createNewCharacter: 'Create New Character',
    myRoleLibrary: 'My Role Library',
    myFriends: 'My Friends',
    llmModel: 'Hot Word Setting',
    voiceSettings: 'Voice Settings',
    myVoiceLibrary: 'My Voice Library',
    roomDesign: 'Room Design',
    actionLibrary: 'Action Library',
    systemRoleSettings: 'System Role Settings',
    voiceSettings: 'Voice Cloning',
    systemParam: 'System Parameters',
    usageLog: 'Usage Log',
    timePlanMenu: 'Time Plans',
    usagePlanMenu: 'Usage Plans',
    deviceInfoMenu: 'Device Info',
    userManageMenu: 'Users',
    orderManageMenu: 'Orders',
    logout: 'Logout',
    aimeeCommunity: 'Amy Community (Beta)',
    community: 'Community'
  },
  login: {
    title: 'User Login',
    codeLogin: 'Code Login',
    passwordLogin: 'Password Login',
    phonePlaceholder: 'Please enter phone number',
    emailPlaceholder: 'Please enter email',
    codePlaceholder: 'Please enter verification code',
    passwordPlaceholder: 'Please enter password',
    getCode: 'Get Code',
    resendAfter: 's to resend',
    login: 'Login',
    forgotPassword: 'Forgot Password',
    register: 'Register',
    phoneRequired: 'Please enter phone number',
    phoneFormatError: 'Please enter a valid phone number',
    emailRequired: 'Please enter email',
    emailFormatError: 'Please enter a valid email address',
    codeRequired: 'Please enter verification code',
    codeFormatError: 'Please enter 6-digit verification code',
    passwordRequired: 'Please enter password',
    passwordLengthError: 'Password length should be between 6-20 characters',
    codeSent: 'Verification code has been sent, please check',
    codeError: 'Verification code is incorrect or expired, please try again',
    loginSuccess: 'Login successful',
    loginError: 'Phone number or password is incorrect, please try again',
    loginErrorEmail: 'Email or password is incorrect, please try again',
    networkError: 'Network error, please try again later',
    getCodeError: 'Failed to get verification code, please try again'
  },
  forgotPassword: {
    title: 'Forgot Password',
    step1: 'Verify Email',
    step2: 'Reset Password',
    step3: 'Complete',
    emailPlaceholder: 'Please enter registered email',
    sendCode: 'Send Verification Code',
    verifyCodePlaceholder: 'Please enter verification code',
    newPasswordPlaceholder: 'Please enter new password',
    resetPassword: 'Reset Password',
    successTitle: 'Password Reset Successful!',
    successMessage: 'Please login with your new password',
    backToLogin: 'Back to Login',
    emailRequired: 'Please enter email address',
    emailFormatError: 'Please enter a valid email address',
    verifyCodeRequired: 'Please enter verification code',
    verifyCodeLengthError: 'Verification code must be 6 digits',
    newPasswordRequired: 'Please enter new password',
    passwordLengthError: 'Password length should be between 6-20 characters',
    codeSent: 'Verification code has been sent to your email',
    resetSuccess: 'Password reset successful',
    resetError: 'Password reset failed, please try again',
    networkError: 'Network error, please try again later'
  },
  register: {
    title: 'User Register',
    phonePlaceholder: 'Please enter phone number',
    emailPlaceholder: 'Please enter email',
    codePlaceholder: 'Please enter verification code',
    passwordPlaceholder: 'Please enter password',
    confirmPasswordPlaceholder: 'Please confirm password',
    getCode: 'Get Code',
    resendAfter: 's to resend',
    register: 'Register',
    hasAccount: 'Already have an account? Login',
    phoneRequired: 'Please enter phone number',
    phoneFormatError: 'Please enter a valid phone number',
    emailRequired: 'Please enter email',
    emailFormatError: 'Please enter a valid email address',
    codeRequired: 'Please enter verification code',
    codeFormatError: 'Please enter 6-digit verification code',
    passwordRequired: 'Please enter password',
    passwordLengthError: 'Password length should be between 6-20 characters',
    confirmPasswordRequired: 'Please enter password again',
    passwordMismatch: 'Passwords do not match',
    codeSent: 'Verification code has been sent, please check',
    registerSuccess: 'Registration successful, redirecting to login page',
    registerError: 'Registration failed, please try again',
    networkError: 'Network error, please try again later',
    getCodeError: 'Failed to get verification code, please try again'
  },
  voiceSettings: {
    title: 'Voice Cloning',
    voiceList: 'Voice List',
    totalCount: 'Total {count} records',
    voiceId: 'Voice ID',
    voiceName: 'Voice Name',
    model: 'Model Name',
    speechRate: 'Speech Rate',
    pitchRate: 'Pitch Rate',
    voiceType: 'Voice Type',
    systemVoice: 'System Voice',
    customVoice: 'Custom Voice',
    status: 'Status',
    audioFile: 'Audio File',
    play: 'Play',
    createTime: 'Create Time',
    updateTime: 'Update Time',
    loadError: 'Failed to load voice list',
    networkError: 'Network error, please try again later',
    noAudioFile: 'No audio file',
    playError: 'Failed to play audio',
    audioPreview: 'Audio Preview',
    index: 'Index',
    addVoice: 'Add Voice',
    addMethod: 'Add Method',
    addMethodRequired: 'Please select add method',
    uploadAudio: 'Upload Audio',
    uploadAudioDesc: 'Upload local audio file to clone voice',
    manualVoiceId: 'Manual ID',
    manualVoiceIdDesc: 'Enter existing voice ID to bind',
    addVoiceTip: 'Add voice feature is under development...',
    voiceNamePlaceholder: 'Please enter voice name',
    voiceNameRequired: 'Please enter voice name',
    voiceNameMaxLength: 'Voice name cannot exceed 50 characters',
    audioFileRequired: 'Please upload audio file',
    uploaded: 'Uploaded',
    reupload: 'Re-upload',
    audioFormatError: 'Only MP3 and WAV audio formats are supported',
    audioSizeError: 'Audio file size cannot exceed 20MB',
    audioSizeErrorUser: 'Audio file size cannot exceed 20MB',
    uploadDurationHint: 'Recommended audio duration is no longer than {seconds} seconds',
    audioDurationReadFailed: 'Unable to read audio duration, please try another file',
    audioDurationLimitExceeded: 'Audio duration exceeds limit (max {seconds}s), please trim and retry',
    uploadSuccess: 'Audio upload successful',
    uploadFailed: 'Audio upload failed',
    addVoiceSuccess: 'Voice added successfully',
    addVoiceFailed: 'Failed to add voice',
    // Voice Cloning Page
    name: 'Name',
    namePlaceholder: 'Please enter name',
    nameExists: 'Name already exists, please use another name',
    nameRequired: 'Please enter name',
    nameMaxLength: 'Name cannot exceed 10 characters',
    audioFileRequiredForClone: 'Please upload audio file first',
    saveToLibrary: 'Save to Voice Library',
    saveSuccess: 'Save successful',
    saveFailed: 'Save failed',
    uploadHint: 'Drag and drop here to upload or click to upload',
    uploadFormatHint: 'Supported formats: MP3, WAV (Max 20MB)',
    pitchRateLabel: 'Pitch',
    speechRateLabel: 'Speech Rate',
    // My Voice Library Page
    myVoiceLibrary: 'My Voice Library',
    operationGuide: 'Operation Guide',
    viewOperationGuide: 'View Operation Guide',
    systemVoiceLibrary: 'System Voice Library',
    index: 'Index',
    voiceName: 'Voice Name',
    category: 'Category',
    gender: 'Gender',
    status: 'Status',
    operation: 'Operation',
    male: 'Male',
    female: 'Female',
    system: 'System',
    created: 'Created',
    enabled: 'Enabled',
    disabled: 'Disabled',
    unknown: 'Unknown',
    edit: 'Edit',
    delete: 'Delete',
    noVoiceData: 'No voice data',
    audioPreview: 'Audio Preview',
    editVoice: 'Edit Voice',
    previewTextPlaceholder: 'Enter preview text (supports Chinese, English, Japanese, Korean, French, Spanish, Italian, German & punctuation, max 20 chars)',
    voicePreview: 'Voice Preview',
    save: 'Save',
    noSystemVoiceData: 'No system voice data',
    useSystemVoice: 'Use System Voice',
    use: 'Use',
    saveToMyVoiceLibrary: 'Save to My Voice Library',
    previewTextRequired: 'Please enter preview text',
    voiceIdNotExists: 'Voice ID does not exist',
    playAudioFailed: 'Failed to play audio, please check audio format',
    previewFailed: 'Preview failed',
    editSuccess: 'Edit successful',
    editFailed: 'Edit failed',
    deleteConfirm: 'Are you sure you want to delete this voice?',
    tip: 'Tip',
    confirm: 'Confirm',
    cancel: 'Cancel',
    deleteSuccess: 'Delete successful',
    deleteFailed: 'Delete failed',
    noAudioFile: 'This voice has no audio file',
    getVoiceListFailed: 'Failed to get voice list',
    getSystemVoiceListFailed: 'Failed to get system voice list',
    saveToMyVoiceLibrarySuccess: 'Successfully saved to My Voice Library',
    saveFailed2: 'Save failed',
    prevStep: 'Previous',
    nextStep: 'Next',
    finish: 'Finish',
    welcomeToMyVoiceLibrary: 'Welcome to My Voice Library',
    myVoiceLibraryDescription: 'This is where you manage all your voices. You can view, edit, play and delete voices you created.',
    systemVoiceLibraryDescription: 'Click the "System Voice Library" button in the upper right corner to view voice templates provided by the system.',
    voiceListTitle: 'Voice List',
    voiceListDescription: 'This shows all the voices you created. You can edit, play or delete each voice.',
    operationButtons: 'Operation Buttons',
    operationButtonsDescription: 'Each voice has operation buttons: Edit can modify the voice name, Play can preview the voice effect, Delete can remove unwanted voices.',
    namePlaceholderForEdit: 'Please enter voice name'
  },
  usageLog: {
    title: 'User Usage Records',
    listTitle: 'Usage Record List',
    exportData: 'Export Data',
    userSN: 'User SN',
    userId: 'User ID',
    userSNPlaceholder: 'Please enter user SN',
    timeRange: 'Time Range',
    quickSelect: 'Quick Select',
    quickSelectPlaceholder: 'Quick select time',
    today: 'Today',
    yesterday: 'Yesterday',
    last7days: 'Last 7 Days',
    last30days: 'Last 30 Days',
    thisMonth: 'This Month',
    lastMonth: 'Last Month',
    query: 'Query',
    reset: 'Reset',
    startDate: 'Start Date',
    endDate: 'End Date',
    to: 'To',
    statistics: 'User Statistics',
    totalAsrDuration: 'Total ASR Duration',
    totalLlmTokens: 'Total LLM Tokens',
    totalTtsTokens: 'Total TTS Tokens',
    totalUsageCount: 'Total Usage Count',
    sn: 'SN',
    usageTime: 'Usage Time',
    asrDuration: 'ASR Duration',
    llmTokens: 'LLM Tokens',
    ttsTokens: 'TTS Tokens',
    usageType: 'Usage Type',
    asr: 'ASR',
    llm: 'LLM',
    tts: 'TTS',
    input: 'Input',
    output: 'Output',
    total: 'Total'
  },
  timePlan: {
    title: 'Time Plan Management',
    add: 'Add plan',
    edit: 'Edit',
    delete: 'Delete',
    name: 'Name',
    originalPrice: 'Original price',
    salePrice: 'Sale price',
    validityPeriod: 'Validity (days)',
    namePlaceholder: 'Plan name',
    operation: 'Actions',
    loadError: 'Failed to load list',
    saveSuccess: 'Saved',
    deleteSuccess: 'Deleted',
    confirmDelete: 'Delete this time plan?',
    tip: 'Notice',
    nameRequired: 'Name is required',
    validityRequired: 'Validity must be greater than 0'
  },
  usagePlan: {
    title: 'Usage plan (tier)',
    cardNormal: 'Standard',
    cardVip: 'VIP',
    emptySlot: 'No plan row. Add records in the plan table first.',
    edit: 'Edit',
    name: 'Tier name',
    asrDurationLimit: 'ASR duration cap',
    ttsTokenLimit: 'TTS token cap',
    llmTokenLimit: 'LLM token cap',
    status: 'Status',
    enabled: 'Enabled',
    disabled: 'Disabled',
    createTime: 'Created',
    updateTime: 'Updated',
    namePlaceholder: 'Tier name',
    operation: 'Actions',
    asrMsHint: 'Unit: milliseconds (ms)',
    loadError: 'Failed to load list',
    saveSuccess: 'Saved',
    nameRequired: 'Name is required',
    asrRequired: 'ASR duration cap is required',
    ttsRequired: 'TTS token cap is required',
    llmRequired: 'LLM token cap is required',
    statusRequired: 'Status is required'
  },
  deviceInfo: {
    title: 'Device Information',
    add: 'Add device',
    edit: 'Edit',
    delete: 'Delete',
    deviceSn: 'Device SN',
    deviceSys: 'OS',
    deviceType: 'Device type',
    deviceInfoJson: 'Device JSON',
    deviceSnPlaceholder: 'Serial number',
    deviceSysPlaceholder: 'e.g. Android / iOS',
    deviceTypePlaceholder: 'Model or type',
    jsonPlaceholder: 'Optional full JSON',
    createTime: 'Created',
    updateTime: 'Updated',
    operation: 'Actions',
    loadError: 'Failed to load list',
    saveSuccess: 'Saved',
    deleteSuccess: 'Deleted',
    confirmDelete: 'Delete this device record?',
    tip: 'Notice',
    snRequired: 'Device SN is required'
  },
  userManage: {
    title: 'Platform users',
    userId: 'User ID',
    nickname: 'Nickname',
    nicknamePlaceholder: 'Search nickname',
    phone: 'Phone',
    phonePlaceholder: 'Search phone',
    email: 'Email',
    emailPlaceholder: 'Search email',
    deviceSn: 'Device SN',
    status: 'Status',
    source: 'Source',
    planId: 'Usage plan',
    planTierColumn: 'Plan',
    planTierFilter: 'Plan',
    planTierNormal: 'Normal',
    planTierVip: 'VIP',
    vipStartTime: 'VIP start',
    vipEndTime: 'VIP expires',
    planPlaceholder: 'Select plan',
    query: 'Search',
    reset: 'Reset',
    all: 'All',
    createTime: 'Registered',
    operation: 'Actions',
    edit: 'Edit',
    recharge: 'Top up',
    rechargeTitle: 'Add subscription time',
    rechargeUser: 'User',
    customDays: 'Days',
    customDaysPlaceholder: 'Number of days',
    customDaysHint: '1–3650 days',
    customDaysRequired: 'Enter a valid number of days',
    customDaysTooLarge: 'Maximum 3650 days per top-up',
    rechargeSuccess: 'Success. Subscription valid until: {end}',
    loadError: 'Failed to load',
    saveSuccess: 'Saved',
    statusNormal: 'Active',
    statusDisabled: 'Disabled',
    sourceWeb: 'Web',
    sourceMp: 'Mini program',
    gender: 'Gender',
    genderPlaceholder: 'Optional',
    genderFemale: 'Female',
    genderMale: 'Male',
    birthday: 'Birthday',
    birthdayPlaceholder: 'Optional',
    nicknameRequired: 'Nickname is required',
    statusRequired: 'Status is required'
  },
  orderManage: {
    title: 'Platform orders',
    orderNo: 'Order no.',
    orderNoPlaceholder: 'Search order no.',
    userId: 'User ID',
    userIdPlaceholder: 'Exact ID',
    userName: 'Nickname',
    userNamePlaceholder: 'Search nickname',
    status: 'Status',
    type: 'Type',
    amount: 'Amount',
    paidAmount: 'Paid',
    timePlanName: 'Time plan',
    createTime: 'Created',
    payTime: 'Paid at',
    startTime: 'Benefit start',
    endTime: 'Benefit end',
    createTimeRange: 'Created',
    to: 'to',
    startDate: 'Start',
    endDate: 'End',
    query: 'Search',
    reset: 'Reset',
    all: 'All',
    statusPending: 'Pending',
    statusActive: 'Active',
    statusDone: 'Completed',
    statusCancelled: 'Cancelled',
    typeMember: 'Membership',
    typeGoods: 'Goods',
    typeRecharge: 'Top-up',
    loadError: 'Failed to load list'
  },
  dashboard: {
    title: 'Dashboard',
    totalUsers: 'Total Users',
    totalOrders: 'Total Orders',
    sales: 'Sales',
    messages: 'Messages'
  },
  createRole: {
    name: 'Name',
    namePlaceholder: 'Please enter name',
    gender: 'Gender',
    selectGender: 'Select gender',
    genderFemale: 'Female',
    genderMale: 'Male',
    genderRequired: 'Please select gender',
    characterBackground: 'Character Background (Prompt)',
    promptPlaceholder: 'Please enter prompt',
    characterVoice: 'Character Voice',
    selectVoice: 'Select character voice',
    setVoice: 'Set Voice',
    wakeWord: 'Wake Word',
    selectWakeWord: 'Select wake word',
    setWakeWord: 'Set Wake Word',
    characterModel: 'Character Model',
    uploaded: 'Uploaded',
    reupload: 'Re-upload',
    dragOrClick: 'Drag and drop here or click to upload',
    modelPreview: 'Model Preview',
    uploadYourModel: 'Upload your model',
    saveToLibrary: 'Save to Library',
    apply: 'Apply',
    youngMale: 'Young Male',
    youngFemale: 'Young Female',
    middleMale: 'Middle Male',
    middleFemale: 'Middle Female',
    missingModelId: 'Missing model ID',
    loadEditDataSuccess: 'Edit data loaded',
    loadFailed: 'Load failed',
    networkError: 'Network error',
    modelLoadFailed: 'Model load failed, please try again',
    uploadModelError: 'Please upload .fbx or .vrm format model file',
    modelLoaded: 'Local model loaded: {name}',
    nameRequired: 'Please enter character name',
    nameMaxLength: 'Character name cannot exceed 10 characters',
    promptRequired: 'Please enter character background (prompt)',
    promptMaxLength: 'Prompt cannot exceed 1000 characters',
    voiceRequired: 'Please select character voice',
    wakeWordRequired: 'Please select wake word',
    modelFileRequired: 'Please select and upload model file first',
    createSuccess: 'Character created successfully!',
    createFailed: 'Creation failed, please try again later',
    operationFailed: 'Operation failed, please check network or try again later',
    language: 'Language',
    forcedOutputLanguage: 'Forced output language',
    selectLanguage: 'Please select language',
    selectForcedOutputLanguage: 'Optional; leave empty for no constraint',
    forcedOutputLanguageYueVoiceHint: 'This is a Cantonese voice; speech output must be Cantonese.',
    languageRequired: 'Please select language',
    languageChinese: 'Chinese',
    languageJapanese: 'Japanese',
    languageKorean: 'Korean',
    languageEnglish: 'English',
    languageFrench: 'French',
    languageSpanish: 'Spanish',
    languageItalian: 'Italian',
    languageGerman: 'German',
    languageCantonese: 'Cantonese'
  },
  myModels: {
    completed: 'Completed',
    modelPreviewNotSupported: 'Model preview not supported',
    characterVoice: 'Character Voice',
    defaultVoice: 'Default Voice',
    format: 'Format',
    characterBackground: 'Character Background (Prompt)',
    chatLog: 'Chat Log (Long-term Memory)',
    edit: 'Edit',
    apply: 'Apply',
    noModels: 'No models, please upload a new model.',
    getListFailed: 'Failed to get model list',
    deleteConfirmTitle: 'Warning',
    deleteConfirmMessage: 'Are you sure you want to delete this role? This action cannot be undone.',
    confirmDelete: 'Confirm',
    cancelDelete: 'Cancel',
    deleteSuccess: 'Role deleted successfully',
    deleteFailed: 'Failed to delete role'
  },
  voiceModels: {
    languageSettings: 'Character Language Settings',
    maxResponseLength: 'Maximum Response Length',
    briefDescription: 'Brief Description (20 words)',
    detailedDescription: 'Detailed Description (100 words)',
    responseSpeed: 'Response Speed',
    fast: 'Fast',
    normal: 'Normal',
    slow: 'Slow',
    hotWordSettings: 'Hot Word Settings',
    wakeWord: 'Wake Word',
    wakeWordPlaceholder: 'Hello Amy',
    interruptConversation: 'Interrupt Conversation',
    interruptPlaceholder: 'Interrupt',
    endConversation: 'End Conversation',
    endPlaceholder: 'Goodbye',
    specialPhrase: 'Special Phrase Recognition',
    specialPhrasePlaceholder: 'Super League',
    specialPhraseDefault: 'Naruto',
    add: 'Add',
    hotWordLibrary: 'Hot Word Library',
    sequence: 'No.',
    hotWord: 'Hot Word',
    category: 'Category',
    operation: 'Operation',
    delete: 'Delete'
  },
  voiceSetting: {
    createVoice: 'Create Voice',
    name: 'Name',
    namePlaceholder: 'Amy Voice',
    pitch: 'Pitch',
    speechRate: 'Speech Rate',
    gender: 'Gender',
    female: 'Female',
    male: 'Male',
    sampleText: 'Sample Text',
    sampleTextPlaceholder: 'Sample Text',
    voicePreview: 'Voice Preview',
    saveToVoiceLibrary: 'Save to Voice Library',
    cloneVoice: 'Clone Voice',
    cloneNamePlaceholder: 'Hello Amy',
    dragOrClick: 'Drag and drop here or click to upload',
    voiceLibrary: 'Voice Library',
    sequence: 'No.',
    voice: 'Voice',
    category: 'Category',
    operation: 'Operation',
    edit: 'Edit',
    delete: 'Delete'
  }
}

